import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { recycling: () => import('./RecyclingPage.vue') },
} satisfies FeatureRoutes
